import {
  Component,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SendEmailModalService } from './send-email-modal.service';
import { ToastrService } from 'ngx-toastr';
import {
  OrderInquiryModal,
  SendEMaill,
  SendEmailResModal,
  ViewOrdersSendEmail,
} from './send-email-modal.model';

@Component({
  selector: 'app-send-email-modal',
  templateUrl: './send-email-modal.component.html',
  styleUrls: ['./send-email-modal.component.scss'],
})
export class SendEmailModalComponent implements OnInit {
  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler() {
    this.closeEditModal();
  }
  @ViewChild('sendToRepModal') private sendToRepModal: TemplateRef<any>;
  @ViewChild('sendCopyOfOrder') private sendCopyOfOrder: TemplateRef<any>;
  private modalRef: BsModalRef;
  public sendEmailForm: FormGroup = <FormGroup>{};
  public sendCopyOfOrderForm: FormGroup = <FormGroup>{};
  public orderdata;
  public orderInquiryData: OrderInquiryModal = <OrderInquiryModal>{};
  public isLoading: boolean = false;

  constructor(
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private emailService: SendEmailModalService,
    private toastrService: ToastrService
  ) {}

  ngOnInit(): void {
    this.createSendToRepForm();
    this.createSendCopyOfOrderForm();
  }

  private createSendToRepForm(): FormGroup {
    return (this.sendEmailForm = this.formBuilder.group({
      id: new FormControl(''),
      createdDate: new FormControl(''),
      customerName: new FormControl(''),
      subject: new FormControl(''),
      description: new FormControl(''),
      totalAmount: new FormControl(''),
    }));
  }

  private createSendCopyOfOrderForm(): FormGroup {
    return (this.sendCopyOfOrderForm = this.formBuilder.group({
      orderId: new FormControl(''),
      customerMailId: new FormControl('', Validators.email),
      salesRepMailId: new FormControl('', Validators.email),
      manufacturerMailId: new FormControl('', Validators.email),
      writtenForMailId: new FormControl('', Validators.email),
    }));
  }

  // This is used tp close the modal.
  public closeEditModal(value: boolean = false): void {
    if (this.modalRef) {
      this.sendEmailForm.reset();
      this.sendEmailForm.updateValueAndValidity();
      this.modalRef.hide();
    }
  }

  private getOrderEnquiryByOrderId(id) {
    this.sendEmailForm.get('id').patchValue(id);
    this.emailService
      .getOrderEnquiryByOrderId(id)
      .subscribe((s: OrderInquiryModal) => {
        this.orderInquiryData = s;
        if (s) {
          this.sendEmailForm.patchValue({
            createdDate: new Date(s.createdDate).toISOString().slice(0, 10),
            customerName: s.customerName,
            totalAmount: s.totalAmount,
          });
        }
      });
  }

  private getEmails(id: string) {
    this.emailService.getEmailsToSend(id).subscribe((s) => {
      this.sendCopyOfOrderForm.patchValue(s);
    });
  }

  open(data) {
    if (data && Object.keys(data).length > 0) {
      this.getOrderEnquiryByOrderId(data.id);
      this.orderdata = data;
      this.sendEmailForm.get('id').patchValue(data.id);
    }
    setTimeout(() => {
      this.modalRef = this.modalService.show(this.sendToRepModal, {
        backdrop: 'static',
        class:
          'modal-lg modal-dialog-centered overflow-auto payment-ngbModal-window',
      });
    }, 600);
  }

  openCopyOfOrder(id: string) {
    if (id) {
      this.sendCopyOfOrderForm.get('orderId').patchValue(id);
      this.getEmails(id);
    }
    setTimeout(() => {
      this.modalRef = this.modalService.show(this.sendCopyOfOrder, {
        backdrop: 'static',
        class: 'modal-dialog-centered overflow-auto payment-ngbModal-window',
      });
    }, 600);
  }

  sendEmail() {
    this.isLoading = true;
    const sendEmailDto: SendEMaill = {
      id: this.sendEmailForm.get('id').value,
      createdDate: new Date(this.sendEmailForm.get('createdDate').value),
      customerName: this.sendEmailForm.get('customerName').value,
      totalAmount: this.sendEmailForm.get('totalAmount').value,
      subject: this.sendEmailForm.get('subject').value,
      description: this.sendEmailForm.get('description').value,
    };
    this.emailService.sendEmailToRep(sendEmailDto).subscribe({
      next: (result: SendEmailResModal) => {
        if (result && result.success) {
          this.isLoading = false;
          this.toastrService.success(result.message);
          this.closeEditModal();
        } else {
          this.isLoading = false;
          if (result.errors && result.errors.length > 0) {
            this.toastrService.error(result.errors[0]);
          } else if (result.errorMessages && result.errorMessages.length > 0) {
            this.toastrService.error(result.errorMessages[0]);
          }
          this.closeEditModal();
        }
      },
      error: (err) => {
        this.isLoading = false;
      },
    });
  }

  sendCopyOfEmail() {
    this.isLoading = true;
    const sendCopyOfEmailDto: ViewOrdersSendEmail = {
      orderId: this.sendCopyOfOrderForm.get('orderId').value,
      customerMailId: this.sendCopyOfOrderForm.get('customerMailId').value,
      salesRepMailId: this.sendCopyOfOrderForm.get('salesRepMailId').value,
      manufacturerMailId:
        this.sendCopyOfOrderForm.get('manufacturerMailId').value,
      writtenForMailId: this.sendCopyOfOrderForm.get('writtenForMailId').value,
    };
    this.emailService.viewOrderSendEmail(sendCopyOfEmailDto).subscribe({
      next: (result) => {
        if (result && result.success) {
          this.isLoading = false;
          this.toastrService.success(result.message);
          this.closeEditModal();
        } else {
          this.isLoading = false;
          if (result.errors && result.errors.length > 0) {
            this.toastrService.error(result.errors[0]);
          } else if (result.errorMessages && result.errorMessages.length > 0) {
            this.toastrService.error(result.errorMessages[0]);
          }
          this.closeEditModal();
        }
      },
      error(err) {
        this.isLoading = false;
      },
    });
  }
}
